export default {
  'app.settings.menuMap.basic': '基本設定',
  'app.settings.menuMap.security': 'セキュリティ設定',
  'app.settings.menuMap.binding': 'アカウントのバインド',
  'app.settings.menuMap.notification': '新しいメッセージの通知',
  'app.settings.basic.avatar': 'アバター',
  'app.settings.basic.change-avatar': 'アバターを変更する',
  'app.settings.basic.email': 'メール',
  'app.settings.basic.email-message': 'メールアドレスを入力してください！',
  'app.settings.basic.nickname': 'ニックネーム',
  'app.settings.basic.nickname-message': 'ニックネームを入力してください！',
  'app.settings.basic.profile': '個人プロフィール',
  'app.settings.basic.profile-message': '個人プロフィールを入力してください!',
  'app.settings.basic.profile-placeholder': '自己紹介',
  'app.settings.basic.country': '国/地域',
  'app.settings.basic.country-message': 'あなたの国を入力してください!',
  'app.settings.basic.geographic': '州または市',
  'app.settings.basic.geographic-message': '地理情報を入力してください!',
  'app.settings.basic.address': '住所',
  'app.settings.basic.address-message': '住所を入力してください!',
  'app.settings.basic.phone': '電話番号',
  'app.settings.basic.phone-message': '電話番号を入力してください!',
  'app.settings.basic.update': '更新情報',
  'app.settings.security.strong': '強い',
  'app.settings.security.medium': 'ミディアム',
  'app.settings.security.weak': '弱い',
  'app.settings.security.password': 'アカウントパスワード',
  'app.settings.security.password-description': '現在のパスワードの強度',
  'app.settings.security.phone': 'セキュリティ電話番号',
  'app.settings.security.phone-description': 'バインドされた電話番号',
  'app.settings.security.question': '秘密の質問',
  'app.settings.security.question-description':
    'セキュリティの質問が設定されてません。セキュリティポリシーはアカウントのセキュリティを効果的に保護できます',
  'app.settings.security.email': 'バックアップメール',
  'app.settings.security.email-description': 'バインドされたメール',
  'app.settings.security.mfa': '多要素認証デバイス',
  'app.settings.security.mfa-description':
    'バインドされていない多要素認証デバイスは、バインド後、2回確認できます',
  'app.settings.security.modify': '変更する',
  'app.settings.security.set': 'セットする',
  'app.settings.security.bind': 'バインド',
  'app.settings.binding.taobao': 'タオバオをバインドする',
  'app.settings.binding.taobao-description':
    '現在バインドされていないタオバオアカウント',
  'app.settings.binding.alipay': 'アリペイをバインドする',
  'app.settings.binding.alipay-description':
    '現在バインドされていないアリペイアカウント',
  'app.settings.binding.dingding': 'ディントークをバインドする',
  'app.settings.binding.dingding-description':
    '現在バインドされていないディントークアカウント',
  'app.settings.binding.bind': 'バインド',
  'app.settings.notification.password': 'アカウントパスワード',
  'app.settings.notification.password-description':
    '他のユーザーからのメッセージは、ステーションレターの形式で通知されます',
  'app.settings.notification.messages': 'システムメッセージ',
  'app.settings.notification.messages-description':
    'システムメッセージは、ステーションレターの形式で通知されます',
  'app.settings.notification.todo': 'To Do（用事) 通知',
  'app.settings.notification.todo-description':
    'To Doタスクは、内部レターの形式で通知されます',
  'app.settings.open': '開く',
  'app.settings.close': '閉じる',
};
